<!-- HomeView.vue -->
<template>
  <div class="home-view">
    <ConnectivityStatus />
    <div class="home-content">
      <template v-if="loading">
        <p>Loading...</p>
      </template>
      <template v-else>
        <h1>Structural Assessment through Radar Remote Sensing</h1>
        <template v-if="authStore.isAuthenticated">
          <h2>Welcome, {{ authStore.username }}. 
            <!-- <div class="centred"><router-link to="/site_edit/new/">Start by defining a new site?</router-link></div> -->
            <div class="centered">
              <!-- <a @click="helpDrawer.openDrawer('Home', helpText)">Click here to get started.</a> -->
              <!-- <a @click="router.push('start-guide')">Click here to get started.</a> -->
              <Button @click="router.push('start-guide')">Click here to get started.</Button>
            </div>
          </h2>
        </template>
        <template v-else>
          <h1>Welcome, please <a @click="showLogin">Log In</a></h1>
        </template>
        <div class="container">
          <div class="hero-container column">
            <HomeHero />
          </div>
          <div class="column">
            <BlogPostList />
          </div>
        </div>
      </template>
      <a href="/termsofservice">Terms of Service</a> | <a href="/privacypolicy">Privacy Policy</a>
      <Button class="hide" @click="helpDrawer.visible=true">?</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import HomeHero from '@/components/HomeHero.vue'
import BlogPostList from '@/components/BlogPostList.vue'
import ConnectivityStatus from '@/components/ConnectivityStatus.vue'
import { ref, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useDrawer } from '@/composables/useDrawer'
import { useRouter } from 'vue-router'

const router = useRouter()  

const loading = ref(true)
const authStore = useAuthStore()
const helpDrawer = useDrawer()
helpDrawer.header = "Get Started"
const helpText = [
  'To get started, you can define a new site by clicking the "New Site" button.',
  'Once you have a site defined, you can upload data, view data, and perform analyses.'
]
const showLogin = () => {
  console.log('pushed link to login')
  authStore.loginDialogVisible = true
  console.log('loginDialogVisible:', authStore.loginDialogVisible)
}

// when mounted, check if the user is authenticated
onMounted(() => {
  loading.value = false
})
</script>

<style scoped>
.home-view {
  position: relative;
}

.home-content {
  padding-top: 0;
  transition: padding-top 0.3s ease;
}

h1, h2 {
  text-align: center;
  /* font-size: 2rem; */
  margin-top: 2rem;
}

.centred {
  font-size: 1.5rem;
  text-align: center;
}

/* Keep the hero centred and resize to less than half page height */
.hero-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  overflow: hidden;
}

/* Base CSS */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  display: flex;
  justify-content: center; /* Center children horizontally */
  gap: 20px; /* Keep space between columns */
  padding: 20px;
  max-width: 80%; /* Or set a specific width */
  margin: 0 auto; /* Center the flex container */
}

.column {
  flex: 1;
  /* Grow columns equally */
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.column h2 {
  margin-top: 0;
}

.hide {
  visibility: hidden;
}
</style>
